import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "../lib/utils";

function PaginationNew({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    
    if (totalPages <= 7) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);
      
      if (currentPage <= 3) {
        // Show first 3 pages, then dots, then last
        pages.push(2, 3);
        pages.push("dots");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Show first, then dots, then last 3 pages
        pages.push("dots");
        pages.push(totalPages - 2, totalPages - 1, totalPages);
      } else {
        // Show first, dots, current-1, current, current+1, dots, last
        pages.push("dots");
        pages.push(currentPage - 1, currentPage, currentPage + 1);
        pages.push("dots");
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  const pageNumbers = getPageNumbers();

  const buttonClass = "h-10 w-10 flex items-center justify-center bg-white border border-[#2F7F571A] rounded-md text-primary cursor-pointer transition-all text-sm hover:bg-gray-50 hover:border-[#2F7F57] hover:text-[#2F7F57] disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <div className="flex gap-2 items-center">
      <button
        className={buttonClass}
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      
      {pageNumbers.map((page, index) => {
        if (page === "dots") {
          return (
            <span key={`dots-${index}`} className="h-10 w-10 flex items-center justify-center text-primary">
              ...
            </span>
          );
        }
        
        return (
          <button
            key={page}
            className={cn(
              buttonClass,
              page === currentPage && "bg-[#2F7F57] border-[#2F7F57] text-white hover:bg-[#256845] hover:text-white hover:border-[#256845]"
            )}
            onClick={() => onPageChange(page)}
            aria-label={`Page ${page}`}
            aria-current={page === currentPage ? "page" : undefined}
          >
            {page}
          </button>
        );
      })}
      
      <button
        className={buttonClass}
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}

export default PaginationNew;
